export const forgotPasswordCode = () => {
  return {
    title: 'UPDATE PASSWORD',
    subtitle_1: 'Please Update your pasword',
    code: 'Code',
    new_password: 'Enter New Password',
    re_enter_new_password: 'Re-enter New Password',
    reset_password: 'Sign In',
    mobile_title: 'Mobile User',
    mobile_message: 'Your password has been reset, please sign in to the FieldTech Connect mobile app.',
    back_to_login: 'Back to Login'
  }
}
